module.exports = __webpack_public_path__ + "img/user.e8b38a71.png";